import { EmergencyNotificationAcknowledgment } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { StyledFlex, Tooltip, TooltipLabel } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { AcknowledgedByCellItem } from './AcknowledgedByCellItem';
import {
   StyledAcknowledgedByCellMoreTooltip,
   StyledAcknowledgedByCellMoreTooltipLabel,
} from './AcknowledgedByCellMoreTooltip.styled';

type AcknowledgedByCellMoreTooltipProps = {
   acknowledgments: EmergencyNotificationAcknowledgment[];
   hiddenCount: number;
};

export const AcknowledgedByCellMoreTooltip = (props: AcknowledgedByCellMoreTooltipProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} justifyContent={'center'}>
         <Tooltip
            testId={'moreAcknowledgments'}
            content={
               <div>
                  <TooltipLabel label={translationKeys.acknowledgedBy} />
                  <StyledFlex direction={'column'} gap={'4px'}>
                     {props.acknowledgments.map((acknowledgment) => (
                        <AcknowledgedByCellItem key={acknowledgment.id} acknowledgment={acknowledgment} />
                     ))}
                  </StyledFlex>
               </div>
            }
         >
            <StyledAcknowledgedByCellMoreTooltip alignItems={'center'} justifyContent={'center'}>
               <StyledAcknowledgedByCellMoreTooltipLabel>
                  {`+${props.hiddenCount}`}
               </StyledAcknowledgedByCellMoreTooltipLabel>
            </StyledAcknowledgedByCellMoreTooltip>
         </Tooltip>
      </StyledFlex>
   );
};
